import { render, staticRenderFns } from "./ElasticMaterialEdit.vue?vue&type=template&id=531eb054&"
import script from "./ElasticMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./ElasticMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports